export function adjustScroll(scrollContainer: HTMLElement | null, itemElement: HTMLElement | null) {
  let observer: IntersectionObserver;
  if (scrollContainer && itemElement) {
    observer = new IntersectionObserver(scrollObserverCb, { root: scrollContainer, threshold: [1] });
    observer.observe(itemElement);
  }

  return () => {
    if (observer) {
      observer.disconnect();
    }
  };
}

export const scrollObserverCb: IntersectionObserverCallback = ([itemEntry], observer) => {
  const itemEl = itemEntry.target;
  observer.unobserve(itemEl);

  const cntrEl = observer.root;
  if (!itemEntry.isIntersecting && cntrEl instanceof Element) {
    const { left, top } = calculateScrollPosition(
      itemEntry.boundingClientRect,
      itemEntry.rootBounds,
      cntrEl,
    );
    cntrEl.scrollTo({
      top,
      left,
      behavior: 'smooth',
    });
  }
};

export function calculateScrollPosition(
  itemRect: { top: number; right: number; left: number; bottom: number } | null,
  cntrRect: { top: number; right: number; left: number; bottom: number } | null,
  { scrollTop, scrollLeft }: { scrollLeft: number; scrollTop: number },
) {
  const thmbBtm = itemRect?.bottom || 0;
  const thmbRght = itemRect?.right || 0;
  const thmbTop = itemRect?.top || 0;
  const thmbLeft = itemRect?.left || 0;
  const cntrBtm = cntrRect?.bottom || 0;
  const cntrRght = cntrRect?.right || 0;
  const cntrTop = cntrRect?.top || 0;
  const cntrLeft = cntrRect?.left || 0;
  const deltaY = thmbBtm > cntrBtm ? thmbBtm - cntrBtm : thmbTop - cntrTop;
  const deltaX = thmbRght > cntrRght ? thmbRght - cntrRght : thmbLeft - cntrLeft;
  const top = scrollTop + deltaY;
  const left = scrollLeft + deltaX;

  return { left, top };
}

export const getVariantNumberToRender = (elementRef: React.RefObject<HTMLDivElement>) => {
  const { current } = elementRef;
  const additionalVariantsToHide = 2;
  if (current) {
    const parentWidth = current.clientWidth;
    let elWidthTotal = 0;
    for (let i = 0; i < current.children.length - 1; i++) {
      elWidthTotal += current.children[i].clientWidth;
      if (elWidthTotal >= parentWidth) {
        return i - additionalVariantsToHide;
      }
    }
    return null;
  }
};

export const getVariantNumberToRenderThreeRows = (elementRef: React.RefObject<HTMLDivElement>) => {
  const { current } = elementRef;
  const additionalVariantsToHide = 2;
  if (current) {
    const parentWidth = current.clientWidth * 3;
    let elWidthTotal = 0;
    for (let i = 0; i < current.children.length - 1; i++) {
      elWidthTotal += current.children[i].clientWidth;
      if (elWidthTotal >= parentWidth) {
        return i - additionalVariantsToHide;
      }
    }
    return null;
  }
};
